import { render, staticRenderFns } from "./jadwalAngsuran.vue?vue&type=template&id=52796877&scoped=true&"
import script from "./jadwalAngsuran.vue?vue&type=script&lang=js&"
export * from "./jadwalAngsuran.vue?vue&type=script&lang=js&"
import style0 from "./jadwalAngsuran.vue?vue&type=style&index=0&id=52796877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52796877",
  null
  
)

export default component.exports